import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

/**
 * Prevents manual navigation into tenant routes after TENANT_INACTIVE was detected.
 * The interceptor is the source of truth for detection; this guard blocks bypass attempts.
 */
export const tenantInactiveGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Tenant inactive UX is tenant-user only.
  if (auth.tenantInactiveVisible() && auth.getUserTypeFromToken() === 'tenant_user') {
    return router.createUrlTree(['/login']);
  }

  return true;
};

